import { VStack } from '@chakra-ui/react';

export default function SpecialOfferView() {
  return (
    <VStack
      bg="greyscale.100"
      p={{ base: 4, md: 6 }}
      borderRadius="lg"
      alignItems="center"
      justifyContent="center"
      spacing={{ base: 10 }}
    >
      Special Offer View
    </VStack>
  );
}
